import { Injectable } from '@angular/core'

@Injectable()
export class ParamsService {
  constructor() {}

  setParam(params, name, value) {
    if (typeof value !== 'undefined' && value != null && value !== '') {
      return params.set(name, value)
    }
    return params
  }
}
